import React, { Component } from "react";
import { MultiSelect } from "react-multi-select-component";
import Api from "./api.js";
import CartComponent from "../OrderSummary/addCartModel.js";
import NotificationSystem from "react-notification-system";

class MultiSelectDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCart: [],
      showModal: false,
    };
    this._notificationSystem = null;
    this.handleSelect = this.handleSelect.bind(this);
    this.getCarts = this.getCarts.bind(this);
    this.setShowModal = this.setShowModal.bind(this);
    this.deleteCart = this.deleteCart.bind(this);
  }

  async componentDidMount() {
    if (this.props.getCarts) {
      this.getCarts();
    }
  }
  

  addNotification(message, level) {
    if (this._notificationSystem) {
      this._notificationSystem.addNotification({
        message: message,
        level: level,
      });
    }
  }
  handleAddToOrderSummary = () => {
    const selectedCarts = this.state.selectedCart.map(item => item.value);

    if (selectedCarts.length === 0) {
      this.addNotification("Please select at least one cart!", "error");
      return;
    }

    if (selectedCarts.length > 1) {
      this.addNotification("Only one cart can be selected at a time!", "error");
      return;
    }

    this.props.addToOrderSummary(selectedCarts[0]);
  };


  deleteCart(event) {
    event.preventDefault();
    const selectedCarts = this.state.selectedCart.map(item => item.value);
    const data = {
      cartId: selectedCarts[0],
      cartStatus: false,
    };
  
    Api.put(`EstimateSummary/DeleteCart`, data)
      .then((response) => {
        this.getCarts();
        this.setState({ selectedCart: [] });
        if (response.data && response.data.data === null) {
          this.addNotification(response.data.message || "Cart action completed successfully!", "success");
      } else {
          this.addNotification("Cart Deleted successfully!", "success");
      }      
      })
      .catch((error) => {
        this.addNotification("Error updating cart: " + error, "error");
      });
  }
  getCarts() {
    this.props.getCarts(); // Call the parent function instead of updating local state
  }

  handleSelect(selected) {
    this.setState({ selectedCart: selected });
  }
  setShowModal = (show) => {
    this.setState({ showModal: show });
  };
  
  handleCreateNewCart = (e) => {
    e.stopPropagation();
    this.setShowModal(true);
  };

  renderOption = ({ checked, option, onClick }) => {
    const isDisabled = this.state.selectedCart.length > 0 && !checked; // Disable if another option is selected
    if (option.value === "save_button") {
      return (
        <div style={{ textAlign: "center", padding: "0px" }}>
          <button
            onClick={this.handleAddToOrderSummary} // Updated function
            style={{
              width: "100%",
              background: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Add to Cart
          </button>
        </div>
      );
    } else if (option.value === "add_new") {
      return (
        <div style={{ textAlign: "center", padding: "5px" }}>
          <span
            onClick={this.handleCreateNewCart}
            style={{
              width: "100%",
              background: "none",
              color: "black",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            <span role="img" aria-label="Add">➕</span> Create New Cart
          </span>
        </div>
      );
    } else if (option.value === "delete_button") {
      return (
        <div style={{ textAlign: "center", padding: "0px" }}>
          <button
            onClick={this.deleteCart}
            style={{
              width: "100%",
              background: "#d55e5e",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >Delete Cart
          </button>
        </div>
      );
    }

    return (
      <div
      onClick={!isDisabled ? onClick : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "5px",
        opacity: isDisabled ? 0.5 : 1, // Dim disabled options
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        readOnly
        disabled={isDisabled}
        style={{ marginRight: "8px" }}
      />
      {option.label}
    </div>
    );
  };

  render() {
    const cartOptions = [
      { label: "➕ Create New Cart", value: "add_new" },
      ...(this.props.cartData?.map((item) => ({
        label: item.cartName,
        value: item.cartId,
      })) || []),
    ];
    let notificationStyle = {
      NotificationItem: {
        DefaultStyle: {
          margin: "10px 5px 2px 1px",
          padding: "30px",
          wordBreak: "break-word",
        },
      },
    };
    const cartOptionsWithSave = [...cartOptions, { label: "🛒 Add to Cart", value: "save_button" }, {label:"Delete Cart", value:"delete_button"}];

    return (
      <div>
        <NotificationSystem
          ref={(notificationSystem) =>
            (this._notificationSystem = notificationSystem)
          }
          style={notificationStyle}
        />
        <MultiSelect
          className="custom-multi-select"
          options={cartOptionsWithSave}
          value={this.state.selectedCart}
          onChange={this.handleSelect}
          labelledBy={this.props.name}
          disableSearch={true}
          hasSelectAll={false}
          overrideStrings={{
            selectSomeItems: this.props.name,
            allItemsAreSelected: this.props.name,
          }}
          valueRenderer={() => this.props.name}
          ItemRenderer={this.renderOption}
          // isOpen={true}
        />
        <CartComponent showModal={this.state.showModal} setShowModal={this.setShowModal} getCarts={this.getCarts} />
      </div>
    );
  }
}

export default MultiSelectDropdown;
